import { presets } from "./text.presets"
import { TextProps } from "./text.props"
import Typography from "@mui/material/Typography"
import { mergeAll, flatten } from "rambdax"
import * as React from "react"

/**
 * For your text displaying needs.
 *
 * This component is a HOC over the built-in React Native one.
 */
export function Text(props: TextProps) {
  // grab the props
  const {
    preset = "default",
    tx,
    text,
    children,
    style: styleOverride,
    txOptions,
    onPress,
    ...rest
  } = props

  // figure out which content to use
  const i18nText = tx
  const content = i18nText || text || children

  const style = mergeAll(flatten([presets[preset] || presets.default, styleOverride]))

  return (
    <Typography
      {...rest}
      onClick={onPress}
      // @ts-ignore
      style={style}>
      {content}
    </Typography>
  )
}
